// Realistic silver cell tower (image) with horizontal broadcast signal waves.
const RINGS = [
  { c: "#22d3ee", d: "0s" },
  { c: "#67e8f9", d: "0.55s" },
  { c: "#7dd3fc", d: "1.1s" },
  { c: "#93c5fd", d: "1.65s" },
  { c: "#f9a8d4", d: "2.2s" },
  { c: "#f472b6", d: "2.75s" },
  { c: "#c084fc", d: "3.3s" },
  { c: "#a855f7", d: "3.85s" },
  { c: "#60a5fa", d: "4.4s" },
  { c: "#38bdf8", d: "4.95s" },
];

export default function HeroTower() {
  return (
    <div
      className="pointer-events-none absolute bottom-[2%] right-[8%] sm:right-[13%] h-[54%] sm:h-[84%] z-[1]"
      aria-hidden="true"
      data-testid="hero-tower"
    >
      <div className="relative h-full">
        <img
          src="/brand/wisp-tower.png"
          alt="Wireless ISP tower"
          className="relative z-10 h-full w-auto object-contain drop-shadow-[0_18px_38px_rgba(0,0,0,0.6)]"
        />
        {/* signal waves emanate from the antenna cluster (behind the tower) */}
        <div className="absolute left-1/2 top-[7%] z-0">
          {RINGS.map((r, i) => (
            <span key={i} className="signal-ring" style={{ borderColor: r.c, animationDelay: r.d }} />
          ))}
        </div>
      </div>
    </div>
  );
}
